import { Icon } from '@design/components/icon/Icon';
import { Input } from '@design/components/input/Input';
import clsx from 'clsx';
import { ChangeEvent } from 'react';

import styles from './Search.module.scss';

interface SearchProps {
  placeholder?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const Search = ({ onChange, placeholder, className }: SearchProps) => {
  return (
    <Input
      className={clsx(styles.styledInput, className)}
      data-testid="scenario-input-search"
      placeholder={placeholder}
      onChange={onChange}
      leftIcon={<Icon iconName="Search" size={20} />}
      autoFocus
    />
  );
};
